'use client';

import React from 'react';
import classNames from 'classnames';
import ShopFooter from '@/features/shop/components/shop-footer.component';
import { useDomainStore } from '@/store/use-domain.store';
import { DefaultFooter } from '@/common/components/themes/footers/default-footer';
// Previous Witro marketplace footers — kept for possible business rollback.
// import HorizontalFooter from './horizontalFooter.component';
// import VerticalFooter from './verticalFooter.component';

interface FooterProps {
  className?: string;
  /** Extra bottom padding for pages that show the mobile bottom nav. */
  offsetMobileNav?: boolean;
}

const Footer = React.forwardRef<HTMLDivElement, FooterProps>(
  ({ className = '', offsetMobileNav = true }: FooterProps, ref?) => {
    const isTenant = useDomainStore((store) => store.isTenant);

    if (isTenant) {
      return className ? (
        <div className={className} ref={ref}>
          <DefaultFooter />
        </div>
      ) : (
        <DefaultFooter />
      );
    }

    return (
      <div className={classNames('w-full', className)} ref={ref}>
        {/* Previous Witro marketplace footers — kept for possible business rollback.
        <VerticalFooter ref={ref} />
        <HorizontalFooter />
        */}
        <ShopFooter offsetMobileNav={offsetMobileNav} />
      </div>
    );
  }
);

Footer.displayName = 'Footer';

export default Footer;
